import request from '@/utils/request'

const biddingDogApi = process.env.VUE_APP_BIDDOG_API

// 设置企业关注
export function followCompanyApi(data) {
  return request({
    url: biddingDogApi + '/biddog/follow/doCompanyFollowStatus',
    method: 'post',
    data
  })
}

// 分页查询企业列表
export function getFollowedCompanyPageApi(params) {
  return request({
    url: biddingDogApi + '/biddog/follow/company/page',
    method: 'get',
    params
  })
}

// 设置项目关注
export function followProjectApi(data) {
  return request({
    url: biddingDogApi + '/biddog/follow/doPurchaseFollowStatus',
    method: 'post',
    data
  })
}

// 是否已关注
export function checkProjectFollowedApi(purchaseId) {
  return request({
    url: biddingDogApi + `/biddog/follow/exitFollowStatus`,
    method: 'get',
    params: { sourcePurchaseId: purchaseId }
  })
}

// 分页查询项目
export function getFollowedProjectPageApi(params) {
  return request({
    url: biddingDogApi + '/biddog/follow/purchase/page',
    method: 'get',
    params
  })
}

// 查询项目详情
export function getFollowedProjectDetailApi(purchaseId) {
  return request({
    url: biddingDogApi + `/biddog/purchaseSearch/${purchaseId}`,
    method: 'get'
  })
}

// 根据项目ID集合查询关注集合
export function findFollowProjectListApi(data) {
  return request({
    url: biddingDogApi + '/biddog/follow/findPurchaseFollowStatusList',
    method: 'post',
    data
  })
}

// 根据企业ID集合查询关注集合
export function findFollowCompanyListApi(data) {
  return request({
    url: biddingDogApi + '/biddog/follow/findCompanyFollowStatusList',
    method: 'post',
    data
  })
}

// 根据企业ID分页查询项目信息
export function getFollowCompanyProjectListApi(params) {
  return request({
    url: biddingDogApi + '/biddog/follow/findPurchaseSearch/page',
    method: 'get',
    params
  })
}
